module.exports = __webpack_public_path__ + "img/menu.710da89c.svg";